<div class="inline-block overflow-x-auto border border-gray-200 rounded-lg">
  <table class="w-auto divide-y divide-gray-200">
    <!-- Table Headings -->
    <thead class="bg-gray-50">
      <tr>
        <th class="px-4 py-3 text-left text-sm font-medium bg-gray-200 text-gray-900 whitespace-nowrap">Business Line</th>
        <th class="px-4 py-3 text-center text-sm font-medium bg-gray-200 text-gray-900 whitespace-nowrap">Referral Appetite</th>
      </tr>
    </thead>

    <!-- Table Body -->
    <tbody class="bg-white divide-y divide-gray-200">
    <tr>
      <td class="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
        Select All
      <td class="px-4 py-3 text-center whitespace-nowrap">
      <div class="flex justify-center gap-2">
        @for (businessLineAppetiteOption of businessLineAppetiteOptions; track businessLineAppetiteOption.appetite) {
          <button type="button"
                  [ngClass]="getAppetiteButtonClasses(businessLineAppetiteOption.appetite, null)"
                  class="inline-flex items-center px-3 py-1 text-xs font-medium cursor-pointer transition-all duration-200 hover:opacity-80 rounded-md whitespace-nowrap"
                  (click)=setAllAppetites(businessLineAppetiteOption)>
          {{businessLineAppetiteOption.displayName}}
        </button>
        }
      </div>
      </td>
    </tr>
      @for (row of tableData; track row.businessLine; let i = $index) {
        <tr [class.bg-gray-50]="i % 2 === 1">
          <!-- Business Line Column -->
          <td class="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
            {{ row.businessLine }}
          </td>

          <!-- Referral Appetite Column -->
          <td class="px-4 py-3 text-center whitespace-nowrap">
            <div class="flex justify-center gap-2">
              @for (businessLineAppetiteOption of businessLineAppetiteOptions; track businessLineAppetiteOption.appetite) {
                <button
                  type="button"
                  [ngClass]="getAppetiteButtonClasses(businessLineAppetiteOption.appetite, row.appetite)"
                  class="inline-flex items-center px-3 py-1 text-xs font-medium cursor-pointer transition-all duration-200 hover:opacity-80 rounded-md whitespace-nowrap"
                  (click)="onAppetiteChange(row.businessLineCode, row.businessLine, businessLineAppetiteOption.appetite)"
                  [title]="getAppetiteTooltip(row.businessLine, businessLineAppetiteOption.appetite)"
                  [attr.aria-pressed]="row.appetite === businessLineAppetiteOption.appetite"
                  [attr.aria-label]="'Set ' + row.businessLine + ' appetite to ' + businessLineAppetiteOption.displayName"
                >
                  {{ businessLineAppetiteOption.displayName }}
                </button>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<!-- Summary Footer -->
<div class="mt-4 flex space-x-8 text-sm">
  <!-- Optional Count -->
  <div class="flex items-center space-x-2">
    <div class="w-4 h-4 bg-yellow-100 border border-yellow-300 rounded"></div>
    <span class="text-gray-600">{{ getAppetiteCount(businessLineAppetiteEnum.OPTIONAL) }} Optional</span>
  </div>

  <!-- Required Count -->
  <div class="flex items-center space-x-2">
    <div class="w-4 h-4 bg-green-100 border border-green-300 rounded"></div>
    <span class="text-gray-600">{{ getAppetiteCount(businessLineAppetiteEnum.REQUIRED) }} Required</span>
  </div>

  <!-- Excluded Count -->
  <div class="flex items-center space-x-2">
    <div class="w-4 h-4 bg-red-100 border border-red-300 rounded"></div>
    <span class="text-gray-600">{{ getAppetiteCount(businessLineAppetiteEnum.EXCLUDED) }} Excluded</span>
  </div>
</div>
